import { IOption } from "component-library";

export function findClosestOption(
  value: any,
  options: IOption<any>[]
): IOption<any> | undefined {
  if (!options.length) {
    return;
  }

  const initial: [IOption<any>[], IOption<any>[]] = [[], []];
  const segments = options.reduce((result, option) => {
    result[option.value <= value ? 0 : 1].push(option);

    return result;
  }, initial);

  const firstSegmentLastItem = segments[0].slice(-1)[0];
  const secondSegmentFirstItem = segments[1][0];

  return value === firstSegmentLastItem.value ||
    Math.abs(firstSegmentLastItem.value - value) <=
      secondSegmentFirstItem.value - value
    ? firstSegmentLastItem
    : secondSegmentFirstItem;
}
